export const DUPLICATE_FIELD_ERROR: string = 'duplicateFields';
export const ALL_OR_NONE_SELECTION_ERROR: string = 'allOrNoneHasValue';